import ApiService from "@/api/apiService";

export interface CountryCodeInformation {
  region: string;
  continent: string;
  marketName: string;
  locales: string[];
  availableToAdministrator: boolean;
}

export type CountryCodeInformationByCountryCode = Record<string, CountryCodeInformation>;

export function getCountriesCode(): Promise<CountryCodeInformationByCountryCode> {
  const queryString = `?additionalInformations=true`;
  return ApiService.api.get(`/admin/supported-country-codes${queryString}`).then(r => r.data);
}
